// **React Imports
import { useMemo } from 'react'

// **Utils Imports
import { DEMO_TENANTS_HOSTNAMES, ROLES } from '../utils/constant'
import { getUserRole } from '../utils/utils'

const useDemoUser = () => {
  // ** variables
  const role = useMemo(() => getUserRole(), [])

  const isDemoTenant = useMemo(() => {
    const hostName = window.location.hostname
    return DEMO_TENANTS_HOSTNAMES.includes(hostName)
  }, [])

  const isDemoUser = useMemo(() => {
    return role?.toLowerCase() === ROLES.DEMO
  }, [role])

  return {
    isDemoUser,
    isDemoTenant
  }
}

export default useDemoUser
